import { z } from 'zod/v4';

import { CustomerDTORuntype } from '../customer/customerBackendTypes';
import { WorkflowTypeRuntype } from '../rfq';

// The Rust side encodes `NonZeroU32`, so we mirror that with a positive-integer
// schema. The drawer UI also clamps to `min={1}` to match the org-level form.
const PositiveIntegerRuntype = z.number().int().min(1);

export const CustomerSpecificSettingsAggregateDTORuntype = z.union([
    z.object({
        setting: z.literal('OrderConfirmationWorkflow'),
        value: WorkflowTypeRuntype,
        customers: z.array(z.string()),
    }),
    z.object({
        setting: z.literal('ManufacturingTemplates'),
        value: z.array(z.string()),
        customers: z.array(z.string()),
    }),
    z.object({
        setting: z.literal('CalculationTemplate'),
        value: z.string(),
        customers: z.array(z.string()),
    }),
    z.object({
        setting: z.literal('FlexibleCalculationTemplate'),
        value: z.object({
            template_id: z.string(),
            checkout_price_line_item: z.string(),
        }),
        customers: z.array(z.string()),
    }),
    z.object({
        setting: z.literal('MinimumLeadTime'),
        value: PositiveIntegerRuntype,
        customers: z.array(z.string()),
    }),
    z.object({
        setting: z.literal('DefaultSourcingLeadTimePreference'),
        value: PositiveIntegerRuntype,
        customers: z.array(z.string()),
    }),
]);
export type CustomerSpecificSettingsAggregateDTO = z.infer<typeof CustomerSpecificSettingsAggregateDTORuntype>;

export const CustomerSpecificSettingsAggregateFormRuntype = z.union([
    z.object({
        setting: z.literal('OrderConfirmationWorkflow'),
        value: WorkflowTypeRuntype,
        customers: z.array(CustomerDTORuntype),
    }),
    z.object({
        setting: z.literal('ManufacturingTemplates'),
        value: z.array(z.string()),
        customers: z.array(CustomerDTORuntype),
    }),
    z.object({
        setting: z.literal('CalculationTemplate'),
        value: z.string(),
        customers: z.array(CustomerDTORuntype),
    }),
    z.object({
        setting: z.literal('FlexibleCalculationTemplate'),
        value: z.object({
            template_id: z.string(),
            checkout_price_line_item: z.string(),
        }),
        customers: z.array(CustomerDTORuntype),
    }),
    z.object({
        setting: z.literal('MinimumLeadTime'),
        value: PositiveIntegerRuntype,
        customers: z.array(CustomerDTORuntype),
    }),
    z.object({
        setting: z.literal('DefaultSourcingLeadTimePreference'),
        value: PositiveIntegerRuntype,
        customers: z.array(CustomerDTORuntype),
    }),
]);
export type CustomerSpecificSettingsAggregateForm = z.infer<typeof CustomerSpecificSettingsAggregateFormRuntype>;

export const CustomerSpecificSettingsAggregateUpdateRequestDTORuntype = z.object({
    add: z.array(CustomerSpecificSettingsAggregateDTORuntype).optional(),
    replace: z.array(CustomerSpecificSettingsAggregateDTORuntype).optional(),
});
